module.exports = __webpack_public_path__ + "static/media/img3.d57ac157.jpg";